import { useEffect,useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { Autocomplete, TextField } from '@mui/material';

import client from '../../../utils/axiosInstance';

const DuplicarEncuestaContent = ({ onSelectionChange, currentCompany }) => {
  const [companies, setCompanies] = useState([]);
  const [maps, setMaps] = useState([]);
  const [selectedMap, setSelectedMap] = useState(null);
  const [loadingCompanies, setLoadingCompanies] = useState(false);
  const [loadingMaps, setLoadingMaps] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const userInfo = JSON.parse(localStorage.getItem('userInfo'));

  useEffect(() => {
    const fetchCompanies = async () => {
      setLoadingCompanies(true);
      try {
        const response = await client.get(`companias/MultiCompani/${userInfo.user}`);
        setCompanies(response.data);
        // Preseleccionar la compañía actual
        if (currentCompany?.id) {
          const found = response.data.find((c) => c.id === currentCompany.id);
          if (found) {
            setSelectedCompany(found);
            onSelectionChange({ companyId: found.id, mapId: '' });
          }
        }
      } catch (error) {
        console.error('Error al obtener compañías', error);
      } finally {
        setLoadingCompanies(false);
      }
    };
    fetchCompanies();
  }, []);

  useEffect(() => {
    if (!selectedCompany) {
      setMaps([]);
      setSelectedMap(null);
      return;
    }
    const fetchMaps = async () => {
      setLoadingMaps(true);
      try {
        const response = await client.get(`GetJorneyMapCompany/${selectedCompany.id}`);
        setMaps(response.data);
        if (response.data.length > 0) {
        setSelectedMap(response.data[0]);
        onSelectionChange({ companyId: selectedCompany.id, mapId: response.data[0].id });
      }
      } catch (error) {
        console.error('Error al obtener mapas', error);
      } finally {
        setLoadingMaps(false);
      }
    };
    fetchMaps();
  }, [selectedCompany]);

  const handleCompanyChange = (_, value) => {
    setSelectedCompany(value);
    setSelectedMap(null);
    onSelectionChange({ companyId: value?.id || '', mapId: '' });
  };

const handleMapChange = (_, value) => {
  setSelectedMap(value);
  onSelectionChange({ companyId: selectedCompany?.id || '', mapId: value?.id || '' });
};

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
      <Typography variant="body2">
        Selecciona la compañía y el mapa destino para duplicar la encuesta.
      </Typography>

      <Autocomplete
        options={companies}
        getOptionLabel={(option) => option.nombreCompania || ''}
        value={selectedCompany}
        onChange={handleCompanyChange}
        loading={loadingCompanies}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Compañía"
            size="small"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loadingCompanies && <CircularProgress size={16} />}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />

      <Autocomplete
        options={maps}
        getOptionLabel={(option) => option.mapJourney || ''}
        value={selectedMap}
        onChange={handleMapChange}
        loading={loadingMaps}
        disabled={!selectedCompany || loadingMaps || maps.length === 0}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Mapa"
            size="small"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loadingMaps && <CircularProgress size={16} />}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </Box>
  );
};

export default DuplicarEncuestaContent;